import React, { useEffect, useState } from "react";
import { Flex, Box } from "rebass/styled-components";
import styled from "styled-components";
import { Error } from "../../../../../components/atoms/form/error";
import { MobileClipCard } from "../../../../../components/organisms/clip/card/mobileCard";
import { Downloading } from "../../../../../components/organisms/clip/card/downloading";

import { Empty } from "../empty";

import { Divider } from "../../../../Components/Divider";
import { InfiniteScroll } from "../../../../Components/ClipFeed/Components/infiniteScroll";

export function MobileClips({
  clipList,
  loading,
  refresh,
  user,
  view,
  hasMoreData,
  paginationClips,
}) {
  const [erroredMobile, setErroredMobile] = useState(false);
  const processed = clipList.filter(
    (item) =>
      ["Processed", "Ready"].includes(item?.mobile[0]?.status) ||
      item?.mobile[0]?.status === "Error"
  );

  const processing = clipList.filter(
    (item) =>
      !["Processed", "Ready", "Inactive"].includes(item?.mobile[0]?.status) &&
      item?.mobile[0]?.status !== "Error"
  );

  //this removes the error message after 5 seconds
  useEffect(() => {
    if (!erroredMobile) return;
    setTimeout(() => {
      return setErroredMobile(false);
    }, 5000);
  }, [erroredMobile]);

  useEffect(() => {
    if (loading) return;
    if (!processing.length) return;

    const intervalId = setInterval(() => {
      refresh(1, true);
    }, 120000);

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [loading, clipList.length]); // eslint-disable-line

  // TODO: would need revamping when we have other aspect ratios

  if (!clipList.length) {
    return (
      <>
        <StyledEmpty isProfile user={user} view={view} />
      </>
    );
  }

  return (
    <>
      {erroredMobile ? (
        <Error>One or more of your Mobile clips failed processing.</Error>
      ) : (
        <></>
      )}
      <Flex mt={[1]} mb={[8, 8, 9, 9]} flexDirection="column">
        <Divider style={{ width: "100%", marginBottom: "50px" }} />
        <InfiniteScroll
          hasMoreData={hasMoreData}
          isLoading={loading}
          onBottomHit={paginationClips}
          loadOnMount={true}
        >
          {" "}
          <StyledGrid
            flexDirection="row"
            flexWrap="wrap"
            justifyContent={["center", "center", "flex-start", "flex-start"]}
          >
            {processing.map(() => (
              <Downloading />
            ))}

            {processed.map((clip) => {
              return <MobileClipCard clip={clip} />;
            })}
          </StyledGrid>
        </InfiniteScroll>
      </Flex>
    </>
  );
}

const StyledGrid = styled(Box)`
  display: grid;
  margin: auto;
  width: 100%;
  ${(props) => `
  grid-row-gap: ${props.singleRow ? 0 : props.theme.space[5]}px;
  grid-column-gap: ${props.theme.space[6]}px;
  grid-template-columns: repeat(3, 1fr);

  @media
  (min-width: ${props.theme.sizes[4] * 3 + props.theme.space[7] * 2 + 1}px)
  {
    grid-template-columns: repeat(4, 1fr);
  }

  @media
  (max-width: ${props.theme.sizes[2] * 3 + props.theme.space[7] * 2 + 1}px)
  {
  max-width: ${props.theme.sizes[4] * 2 + props.theme.space[4] * 1}px;
    grid-template-columns: repeat(2, 1fr);
  }
  @media
  (max-width: ${props.theme.sizes[2] * 2 + props.theme.space[7] + 1}px)
  {
  max-width: ${props.theme.sizes[4]}px;
  grid-template-columns: repeat(2, 1fr);
  grid-row-gap: ${props.singleRow ? 0 : props.theme.space[7]}px;
  grid-column-gap: ${props.theme.space[4]}px;
}
`}
`;

const StyledEmpty = styled(Empty)`
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  top: 0;
`;
